import type { SmsStaffWebEnvironment } from './environment.type';

export const environment: SmsStaffWebEnvironment = {
  production: false,
  smsApiBaseUrl: 'https://sms-api-staging.schoolbell-e.com',
  commerceWebBaseUrl: 'https://commerce-staging.schoolbell-e.com',
};
